import React from "react";
import styles from "./innermysteries.module.css";
import Image from "next/image";
import { Button } from "@mui/material";
import Head from "next/head";

import banner from "../../public/image/inner-mysteries/inner_mysteries_page_bnr_right_img.webp";
import divineLogo from "../../public/image/inner-mysteries/divine_logo_img.webp";

import block1 from "../../public/image/inner-mysteries/inner_mysteries_page_block1_img.webp";
import block2 from "../../public/image/inner-mysteries/inner_mysteries_page_block2_img.webp";
import block3 from "../../public/image/inner-mysteries/inner_mysteries_page_block3_img.webp";
import block4 from "../../public/image/inner-mysteries/inner_mysteries_page_block4_img.webp";
import block5 from "../../public/image/inner-mysteries/inner_mysteries_page_block5_img.webp";
import block6 from "../../public/image/inner-mysteries/inner_mysteries_page_block6_img.webp";
import block7 from "../../public/image/inner-mysteries/inner_mysteries_page_block7_img.webp";
import sacredBlueprint from "../../public/image/inner-mysteries/inner_mysteries_block8_sacred_blueprint_img.webp";
import rajaYoga from "../../public/image/inner-mysteries/inner_mysteries_block8_raja_yoga_img.webp";
import kriyaKundalini from "../../public/image/inner-mysteries/inner_mysteries_block8_kriya_kundalini_img.webp";
import tantricKundalini from "../../public/image/inner-mysteries/inner_mysteries_block8_tantric_kundalini_img.webp";
import planetaryMeditations from "../../public/image/inner-mysteries/inner_mysteries_block8_planetary_meditations_img.webp";
import grandInvocation from "../../public/image/inner-mysteries/inner_mysteries_block8_grand_invocation_img.webp";
import banishingPentagram from "../../public/image/inner-mysteries/inner_mysteries_block8_banishing_pentagram_img.webp";
import invokingPentagram from "../../public/image/inner-mysteries/inner_mysteries_block8_invoking_pentagram_img.webp";
import invocationDivine from "../../public/image/inner-mysteries/inner_mysteries_block8_invocation_divine_img.webp";
import openingGates from "../../public/image/inner-mysteries/inner_mysteries_block8_opening_gates_img.webp";
import planetaryInvocations from "../../public/image/inner-mysteries/inner_mysteries_block8_planetary_invocations_img.webp";
import zodiacalInvocations from "../../public/image/inner-mysteries/inner_mysteries_block8_zodiacal_invocations_img.webp";
import block10 from "../../public/image/inner-mysteries/inner_mysteries_page_block10_img.webp";
import block11 from "../../public/image/inner-mysteries/inner_mysteries_page_block11_img.webp";
import block12 from "../../public/image/inner-mysteries/inner_mysteries_page_block12_img.webp";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";


function index() {
  return (
    <>
      <Head>
        <title>Inner Mysteries | School of Our Divine Infinite Being</title>
      </Head>

      <div className={styles.inner_mysteries_page_main}>
        <div className={styles.common_width}>
          <div className={styles.inner_mysteries_page_bnr_sec_main}>
            <div
              className={`${styles.inner_mysteries_page_bnr_sec_wrpr} ${styles.flex_direction_reverse}`}
            >
              <div className={styles.bnr_image_section}>
                <Image src={banner} alt="Banner Image" />
              </div>
              <div className={styles.bnr_content_section_main}>
                <div className={styles.content_section}>
                  <div className={styles.logo_section}>
                    <Image src={divineLogo} alt="Divine Logo" />
                  </div>

                  <h1 className={styles.grey_cont_65}>
                    A welcome Invitation to the Inner{" "}
                    <span style={{ color: "#fcff00" }}>Mystery 15 month</span>{" "}
                    program with the School of our Divine Infinite Being
                  </h1>

                  {/* <Button className={styles.gradient_button}>
                    Entering the Order through the Gates of the Year
                  </Button> */}
                  <div className={styles.gradient_button}>
                    Entering the Order through the Gates of the Year
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.inner_mysteries_page_block_sec_main}>
            <div className={styles.inner_mysteries_block1_main}>
              <div className={styles.image_section}>
                <Image src={block1} alt="Block-1 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <h3 className={styles.grey_heading_37}>Beloved Seeker,</h3>
                  <p className={styles.grey_cont_25}>
                    The depth of study required for a Priest or Priestess of our
                    Mystery Tradition, within the{" "}
                    <span>School of our Divine Infinite Being</span>, rests upon
                    three great pillars:
                  </p>

                  <div className={styles.padding_left_35}>
                    <div className={styles.heading_flex}>
                      <p
                        className={`${styles.green_heading} ${styles.right_mrgn}`}
                      >
                        1.
                      </p>
                      <p className={styles.green_heading}>
                        Our Central Doctrine
                      </p>
                    </div>
                    <div className={styles.padding_left_30}>
                      <p className={styles.grey_cont_25}>
                        Nearly 500 pages of teaching that reveal our Ontological
                        Design as a Platonic Mystery Tradition—one interwoven
                        with the wisdom of <span>Vedanta and Tantra</span>, and
                        illumined by modern{" "}
                        <span>scientific and psychological models</span>. This
                        text forms the intellectual and spiritual architecture
                        of our School. It is available for purchase on Amazon
                        and is also freely accessible on our website in webpage
                        format and video format on our YouTube channel.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block2_main} ${styles.flex_direction_reverse}`}
            >
              <div className={styles.image_section}>
                <Image src={block2} alt="Block-2 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <div className={styles.heading_flex}>
                    <p
                      className={`${styles.green_heading} ${styles.right_mrgn}`}
                    >
                      2.
                    </p>
                    <p className={styles.green_heading}>
                      Ritual Praxis and Instruction
                    </p>
                  </div>
                  <div className={styles.padding_left_30}>
                    <p className={styles.grey_cont_25}>
                      More than <span>530 pages of instruction</span> devoted to
                      the full breadth of our Yogic disciplines and the{" "}
                      <span>Theurgic Ritual Praxis of the School</span>. This is
                      the manual of transformation, practice, and alignment—our
                      living grammar of invocation. It is available for purchase
                      on Amazon and is also freely accessible on our website in
                      webpage format, though those who purchase the text receive
                      additional materials.
                    </p>
                  </div>
                  <div className={styles.heading_flex}>
                    <p
                      className={`${styles.green_heading} ${styles.right_mrgn}`}
                    >
                      3.
                    </p>
                    <p className={styles.green_heading}>
                      The Symbolic Power of ROTA
                    </p>
                  </div>
                  <div className={styles.padding_left_30}>
                    <p className={styles.grey_cont_25}>
                      The study of the{" "}
                      <span>
                        Astrological Wheel within our Divine Arcana Tarot
                      </span>
                      , the sacred book of images and symbols that teaches by
                      vision as much as by word. The deck may be purchased
                      directly through our website, while the complete training
                      in its use is made freely available on our YouTube
                      channel.
                    </p>
                  </div>
                  <p className={styles.grey_cont_25}>
                    These three pillars support the{" "}
                    <span>15-month dedication:</span> a path of
                    self-empowerment, entrance into the divinity of the Zodiac,
                    and the active embodiment of our instructions in{" "}
                    <span>Yoga, invocation, and theurgical ritual praxis</span>.
                    Together they form the ground upon which a Priest or
                    Priestess of our Order is built.
                  </p>

                  <Button className={styles.blue_button}>
                    Join the Mystery School of Our Divine Infinite Being
                  </Button>
                </div>
              </div>
            </div>

            <div
              className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block3_main}`}
            >
              <div className={styles.image_section}>
                <Image src={block3} alt="Block-3 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <p className={styles.grey_cont_25}>
                    Our{" "}
                    <span>
                      inner Mystery Tradition is not apart from the greater body
                      of our work—our Perennial Mandalan faith and Astrology
                      community
                    </span>
                    , nor from our <span>Academy for Diviners</span>, where
                    students train to become professional readers of the sacred
                    arts. Yet it stands distinct, reserved for those who feel
                    its rhythm call in resonance with their own soul.
                    Participation in this path does not require entry into any
                    of our other programs.
                  </p>

                  <p className={styles.grey_cont_25}>
                    This program is for those who are called to the{" "}
                    <span>path of theurgy and ritual praxis</span>—those who
                    would walk the disciplines that prepare them to be
                    consecrated as{" "}
                    <span>Priests and Priestesses of our Order</span>, bearers
                    of the flame and keepers of the gates.
                  </p>

                  <p className={styles.grey_cont_25}>
                    If you have come to this threshold, it is because something
                    ancient, intelligent, and eternal within you has stirred.
                    The stars have whispered, the daemons have turned their
                    faces toward you, and your own soul has answered. You are
                    already in communion with a living Presence older than
                    memory—the radiance that binds heaven and earth in one song.
                  </p>
                </div>
              </div>
            </div>

            <div
              className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block4_main} ${styles.flex_direction_reverse}`}
            >
              <div className={styles.image_section}>
                <Image src={block4} alt="Block-4 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <p className={styles.grey_cont_25}>
                    To be <span>a theurgist</span> is to take one’s stand not
                    merely as a student of wisdom, but as a{" "}
                    <span>participant in the divine order itself</span>. It is
                    to live as one who dares to summon the gods, not with
                    arrogance, but with reverence; not to command, but to align
                    with the eternal harmonies that bind cosmos and soul.
                  </p>

                  <p className={styles.grey_cont_25}>
                    The great philosopher-priest <span>Iamblichus</span>{" "}
                    declared that philosophy alone could not ascend the
                    soul—that only through theurgy, through ritual acts
                    sanctified by divine symbols, could a mortal participate in
                    immortality. Theurgy is the binding of heaven and earth in
                    the body of the practitioner, the deliberate union of the
                    finite with the infinite. It is the practice by which signs
                    (sēmeia) and tokens (symbola) open into living gateways,
                    where gods and daemons descend and the soul is raised into
                    their company.
                  </p>

                  <p className={styles.grey_cont_25}>
                    Thus, to walk the path of our Mystery Tradition is to choose
                    a life of <span>radiant discipline and sacred daring</span>.
                    The theurgist in our order enters into sacred dialogue with
                    the house of the Sun and the mysteries of the zodiac. They
                    align themselves with the Solar Current, not to escape fate
                    but to participate knowingly in its unfolding, bearing
                    responsibility for shaping life in harmony with the divine
                    intelligences.
                  </p>
                </div>
              </div>
            </div>

            <div
              className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block5_main}`}
            >
              <div className={styles.image_section}>
                <Image src={block5} alt="Block-5 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <p className={styles.grey_cont_25}>
                    To be a Priest or Priestess in our Order is to become more
                    than an officiant of rites: it is to be a guardian of
                    thresholds, a bearer of flame, and a living symbol of the
                    covenant between gods and mortals. Such a one does not
                    merely believe—they embody. They do not merely speak—they
                    invoke. They do not merely hope—they enact.
                  </p>

                  <p className={styles.grey_cont_25}>
                    This is the calling of the theurgist: to live as one whose
                    very breath and gesture resonate with the rhythm of
                    eternity, whose consecrated life becomes a bridge by which
                    others may cross into the light of their own Divine Infinite
                    Being.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.inner_mysteries_block6_main_box}>
              <h2 className={styles.bg_shadow_heading}>
                What our 15 month dedication Demands—and Gives
              </h2>
              <h2 className={styles.grey_heading_50}>
                What <span>our 15 month dedication Demands</span>—and Gives
              </h2>
              <p className={styles.grey_cont_25}>
                <strong>Time:</strong> plan 3–6 hours per week during the first
                three months (the most intensive phase), then a steady cadence
                through the decan cycle (at least one full decan working within
                each 10-day window, with daily practice recommended).
              </p>
              <div
                className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block6_main}`}
              >
                <div className={styles.image_section}>
                  <Image src={block6} alt="Block-6 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p className={styles.grey_cont_25}>
                      <strong>Consistency:</strong> you will receive one decan
                      at a time only once the cycle begins. Each decan opens 3
                      days early to let you prepare.
                    </p>

                    <p className={styles.grey_cont_25}>
                      <strong>Study + Vision:</strong> before each decan, you
                      will review short training videos (sign, planet, and the
                      specific Minor Arcana card), work a 10-minute Raja Yoga
                      clearing, then scry the decan’s card and journal the
                      results.
                    </p>

                    <p className={styles.grey_cont_25}>
                      <strong>Lineage:</strong> upon completing the full
                      36-decan journey, you may apply to be recognized as a
                      Priest or Priestess of the Order, with the authority to
                      initiate others and found chapters. This is sacred
                      responsibility, and every step of the curriculum prepares
                      you for it.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block7_main} ${styles.flex_direction_reverse}`}
            >
              <div className={styles.image_section}>
                <Image src={block7} alt="Block-7 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <h2 className={styles.grey_heading_50}>
                    The <span>Architecture</span> of the 15 Months
                  </h2>
                  <h3 className={styles.grey_heading_37}>
                    Gatekeeping the Beginning (Your Start Date)
                  </h3>

                  <p className={styles.grey_cont_25}>
                    You must choose a Solstice (approximately June 21 or
                    December 21) or an Equinox (approximately March 20 or
                    September 22) as your entry gate.
                  </p>

                  <p className={styles.grey_cont_25}>
                    Three weeks before your first decan unlocks, you receive
                    early access to orient, gather your materials, and set your
                    practice rhythm.
                  </p>

                  <Button className={styles.blue_button}>
                    “Enter the Mystery School Today”
                  </Button>
                </div>
              </div>
            </div>

            <div className={styles.inner_mysteries_block8_main}>
              <div className={styles.inner_mysteries_block8_main_box}>
                <div className={styles.orange_bar}>
                  <h2>A brief horizon of the twelve</h2>
                </div>

                <div className={styles.block8_main_wrpr}>
                  <div
                    className={`${styles.color_box_main} ${styles.blue_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image src={sacredBlueprint} alt="Sacred Blueprint" />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>The Sacred Blueprint</h4>
                      <p>
                        Your natal chart as a living pattern; begin daily study
                        with the Theurgic Ritual of the Pentagram.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.light_green_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image src={rajaYoga} alt="Raja Yoga" />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Raja Yoga</h4>
                      <p>
                        Training the inner Observer; sovereign stillness and
                        clean attention.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.violet_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image src={kriyaKundalini} alt="Kriya Kundalini" />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Kriya Kundalini Yoga</h4>
                      <p>
                        The seven-posture current; breathing the spine awake.
                      </p>
                    </div>
                  </div>

                  <div className={`${styles.color_box_main} ${styles.red_box}`}>
                    <div className={styles.icon_section}>
                      <Image src={tantricKundalini} alt="Tantric Kundalini" />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Tantric Kundalini (Chakra Embodiment)</h4>
                      <p>
                        Each center as a seat of Shakti; journaling the subtle
                        body.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.tiffany_blue_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image
                        src={planetaryMeditations}
                        alt="Planetary Meditations"
                      />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Planetary Meditations</h4>
                      <p>
                        Meeting the cosmic intelligences by direct imaginal
                        contact.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.yellow_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image src={grandInvocation} alt="The Grand Invocation" />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>The Grand Invocation</h4>
                      <p>
                        Aligning microcosm and macrocosm; establishing ritual
                        axis.
                      </p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.green_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image
                        src={banishingPentagram}
                        alt="Banishing Pentagram"
                      />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Banishing Pentagram</h4>
                      <p>Purifying and sealing the field.</p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.pink_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image src={invokingPentagram} alt="Invoking Pentagram" />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Invoking Pentagram</h4>
                      <p>
                        Calling the elemental powers into the temple of the
                        body.
                      </p>
                    </div>
                  </div>

                  <div className={`${styles.color_box_main} ${styles.sky_box}`}>
                    <div className={styles.icon_section}>
                      <Image
                        src={invocationDivine}
                        alt="Invocation of Our Divine Infinite Being"
                      />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Invocation of Our Divine Infinite Being</h4>
                      <p>Heart of the Mystery School practice.</p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.purple_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image src={openingGates} alt="Opening of the Gates" />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Opening of the Gates</h4>
                      <p>An intensive cycle with the elemental gates.</p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.grey_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image
                        src={planetaryInvocations}
                        alt="Planetary Invocations (without the Gates)"
                      />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Planetary Invocations (without the Gates)</h4>
                      <p>Names, gestures, concentrations.</p>
                    </div>
                  </div>

                  <div
                    className={`${styles.color_box_main} ${styles.brass_gold_box}`}
                  >
                    <div className={styles.icon_section}>
                      <Image
                        src={zodiacalInvocations}
                        alt="Zodiacal Invocations (without the Gates)"
                      />
                    </div>

                    <div className={styles.right_content_section}>
                      <h4>Zodiacal Invocations (without the Gates)</h4>
                      <p>The twelve signs as presences and powers.</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className={styles.grey_cont_25}>
                <span>Note:</span> Before the first decan of any sign, you will
                watch the <span>sign’s Tarot training video</span> once; before
                each decan you will watch and/or rewatch the{" "}
                <span>planetary Tarot training</span> and the{" "}
                <span>Minor Arcana card</span> video specific to that decan.
              </p>
            </div>

            <div className={styles.inner_mysteries_block9_main}>
              <div className={styles.green_heading_bar}>
                <h2>Phase II — The Decan Year (Months 4–15): The 36 Faces</h2>
              </div>

              <p className={styles.grey_cont_25}>The decans are ten-day windows of highly specific influence and teaching. You will receive <span>one decan at a time; each opens 3 days early</span> so you can prepare. Your minimum <span>commitment is to complete the full working at least once within each 10-day period; daily</span> invocation and journaling are <span>recommended</span> when possible.</p>

              <div className={styles.inner_mysteries_block9_main_wrpr}>
                <div className={`${styles.bullet_cont_box} ${styles.block9_blue_box}`}>
                  <div className={styles.heading_flex}>
                    <h3 className={`${styles.white_heading_42} ${styles.padding_right_6}`}>1.</h3>
                    <h3 className={styles.white_heading_42}>Study</h3>
                  </div>
                  <p className={styles.white_bullet_cont}>Re-watch the planetary Tarot video for the decan’s ruling planet.</p>
                  <p className={styles.white_bullet_cont}>Watch the Minor Arcana video specific to the decan. Take notes on correspondences and impressions.</p>
                </div>

                <div className={`${styles.bullet_cont_box} ${styles.block9_violet_box}`}>
                  <div className={styles.heading_flex}>
                    <h3 className={`${styles.white_heading_42} ${styles.padding_right_6}`}>2.</h3>
                    <h3 className={styles.white_heading_42}>Raja Yoga (10 minutes)</h3>
                  </div>
                  <p className={styles.white_bullet_cont}>Prior to the ritual, clear the interior field. Breathe, witness, and enter stillness. Consider adding in some Kria Kundalini ahead of this as well</p>
                  <p className={styles.white_bullet_cont}>Allow awareness to settle into presence.</p>
                </div>

                <div className={`${styles.bullet_cont_box} ${styles.block9_green_box}`}>
                  <div className={styles.heading_flex}>
                    <h3 className={`${styles.white_heading_42} ${styles.padding_right_6}`}>3.</h3>
                    <h3 className={styles.white_heading_42}>Place the Cards on the Altar</h3>
                  </div>
                  <p className={styles.white_bullet_cont}>Set the Sign’s Tarot card on one side and the Planet’s Tarot card on the other.</p>
                  <p className={styles.white_bullet_cont}>Place the decan’s Minor Arcana between them.</p>
                  <p className={styles.white_bullet_cont}>This establishes the circuit: <strong>Sign – Planet – Decan,</strong> a living channel of influence awaiting activation.</p>
                </div>

                <div className={`${styles.bullet_cont_box} ${styles.block9_crimson_box}`}>
                  <div className={styles.heading_flex}>
                    <h3 className={`${styles.white_heading_42} ${styles.padding_right_6}`}>4.</h3>
                    <h3 className={styles.white_heading_42}>Celestial Invocation of the Pentag</h3>
                  </div>
                  <p className={styles.white_bullet_cont}>Perform the Invocation, calling upon the <strong>Daemon, the Sign, and the Planet</strong> of the decan.</p>
                  <p className={styles.white_bullet_cont}>This rite opens the field, draws down the celestial current, and anchors the spirit of the decan into presence.</p>
                  <p className={styles.white_bullet_cont}>We have recorded a <strong>full video for each decan</strong> that you are welcome to follow in real time, or to study as preparation working from your journal.</p>
                </div>

                <div className={`${styles.bullet_cont_box} ${styles.block9_raspberry_box}`}>
                  <div className={styles.heading_flex}>
                    <h3 className={`${styles.white_heading_42} ${styles.padding_right_6}`}>5.</h3>
                    <h3 className={styles.white_heading_42}>Scry the Decan Card</h3>
                  </div>
                  <p className={styles.white_bullet_cont}>Turn your attention to the Minor Arcana already placed upon the altar. Do this very soon after the ritual has been performed.</p>
                  <p className={styles.white_bullet_cont}>Let its image, emotion, and resonance arise.</p>
                  <p className={styles.white_bullet_cont}>Allow imagination to deepen into the symbolic nature of the Tarot card, guided by the daemon’s presence.</p>
                </div>

                <div className={`${styles.bullet_cont_box} ${styles.block9_sky_box}`}>
                  <div className={styles.heading_flex}>
                    <h3 className={`${styles.white_heading_42} ${styles.padding_right_6}`}>6.</h3>
                    <h3 className={styles.white_heading_42}>Journal</h3>
                  </div>
                  <p className={styles.white_bullet_cont} style={{color: "#ffffff"}}>Record what the card reveals: how it reflects your past, how it touches your present, and how the <strong>daemon of the decan</strong> may guide you moving forward</p>
                  <p className={styles.white_bullet_cont} style={{color: "#ffffff"}}>Journal inside our system or privately; if privately, photograph and upload your entry to preserve the record.</p>
                </div>
              </div>
            </div>

            <div
              className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block10_main} ${styles.flex_direction_reverse}`}
            >
              <div className={styles.image_section}>
                <Image src={block10} alt="Block-10 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <p className={styles.grey_cont_25}><span>You will also have access to the instructor’s personal audio journaling for most days within each decan—a living record of companionship and example as you walk the same ground.</span> Eddie Paredes himself followed this model with devotion, engaging the process daily across an entire year, save only those rare days when travel or unavoidable events intervened. What you will hear are the resonant traces of a path actually walked: <span>real struggles, insights, breakthroughs, and the living voice of the work in motion</span>. This treasury of recordings is reserved solely for our students, offering you not only instruction but the rare intimacy of practicing alongside one who has trod the whole circuit of the decans. It is a companionable guide and a demonstration of what becomes possible when the method is lived with constancy and daring.</p>
                </div>
              </div>
            </div>

            <div className={styles.inner_mysteries_block11_main}>
              <div className={styles.green_heading_bar}>
                <h2>Applying to the Mystery School</h2>
              </div>
              <div
              className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block11_main}`}
              >
                <div className={styles.image_section}>
                  <Image src={block11} alt="Block-11 Image" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p className={styles.grey_cont_25}><span>The first wave of initiates will be activated on the Summer Solstice of 2027.</span> Applications may be filled at any time, but entrance is aligned only with the cardinal thresholds of the year—the Solstices and Equinoxes.</p>

                    <p className={styles.grey_cont_25}>When you are accepted, your journey begins with a <span>twelve-week intensive at that turning of the heavens</span>. These first twelve weeks are not the decanic work itself but the path of consecration: a period of clearing, preparation, and radiant discipline. It is here that the rhythm of study, ritual, and reflection is established—laying the ground upon which the Mysteries can be received.</p>

                    <p className={styles.grey_cont_25}>At the <span>following Solstice or Equinox</span>, you formally cross the threshold into the <span>first decan</span>. From that moment onward, you enter the living circuit of the decanic year, moving face by face under the guardianship of their daemons, guided by the planetary currents, and instructed by the Tarot. The twelve-week intensive is the fire that tempers you; the decanic cycle is the temple that opens before you.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div
            className={`${styles.inner_mysteries_block1_main} ${styles.inner_mysteries_block12_main} ${styles.flex_direction_reverse}`}
            >
              <div className={styles.image_section}>
                <Image src={block12} alt="Block-12 Image" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <p className={styles.grey_cont_25}>This path demands planning and intention. You must select a season in which you can dedicate yourself wholly, especially in those opening twelve weeks. If your life cannot yet hold this weight, wait until it can—the work is too potent to be entered half-heartedly. But when you are ready, the current itself will meet you.</p>

                  <p className={styles.grey_cont_25}>To begin at a Solstice or Equinox is to step into the turning hinge of time, when heaven and earth shift their balance. Few thresholds are more charged with cosmic potency. By aligning your life to these great gates, you join your becoming to the rhythm of the Sun and the intelligences that govern our world.</p>

                  <p className={styles.grey_cont_25}>Do not delay lightly. The Mysteries are alive, and they are waiting. If you are ready to dedicate yourself, the Solstice and Equinox stand open before you. Cross that threshold—and the Work begins.</p>

                  <Button className={styles.blue_button}>“Awaken Your Path — Join the Mystery School”</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MysteryBannerNew/>
    </>
  );
}

export default index;
